export const ita = {
  _LOGIN: {
    _EMAIL: "Email",
    _PASSWORD: "Password",
    _REMEMBER: "Ricordami",
    _LOGIN: "ACCEDI",
    _SIGNUP: "Registrati",
    _FORGOTPASSWORD: "Hai dimenticato la password?",
    _NOACCOUNT: "Non hai un account?",
    _ERROR_EMAIL: "Sembra che tu non sia registrato! Riprova.",
    _ERROR_PASSWORD: "Password errata",
    _SUCCESS: "Accesso riuscito",
  },
  _REGISTER: {
    _REGISTER: "Registrati",
    _NAME: "Nome utente",
    _EMAIL: "La tua email",
    _PASSWORD: "La tua password",
    _CONFIRMPASSWORD: "Conferma password",
    _WHATSAPP: "WhatsApp",
    _TELEGRAM: "Telegram (opzionale)",
    _HAVEACCOUNT: "Ho già un account",
    _ERROR_REFERAL: "Codice di invito errato",
    _ERROR_EMAIL: "Questa email esiste già",
    _SUCCESS: "Registrazione riuscita",
  },
  _SIDEBAR: {
    _PAGES: "Pagine",
    _OPEN: "Apri barra laterale",
    _DASHBOARD: "Home",
    _NETWORK: "Rete",
    _FINANCE: "Portafoglio",
    _PACKAGES: "Piani",
    _SIGNOUT: "Esci",
    _LANGUAGE: "Lingua",
    _PROFILE: "Profilo",
    _AUTH: "Autenticatore",
  },
  _DASHBOARD: {
    _TITLE: "Saldo",
    _TITLE2: "Deposito",
    _TITLE3: "Guadagni Totali",
    _TITLE4: "Guadagni Unilevel",
    _TITLE5: "Bonus di Abbinamento Infinito",
    _TITLE6: "Piano",
    _TITLE7: "Bonus di Inizio Unilevel",
    _TITLE8: "Bonus Binario",
    _TITLE9: "Bonus di Abbinamento Binario",
    _TITLE10: "Bonus Residuo del COPY TRADING",
    _TOTAL: "Totale",
    _TABLE3: "Lista dei pacchetti",
    _START: "Inizia",
    _FINISH: "Fine",
    _STATUS: "Stato",
    _STATUS_ACTIVE: "Attivo",
    _STATUS_INACTIVE: "Inattivo",
    _CURRENT: "Attuale",
    _UPGRADE: "Aggiorna",
    _COPYMESSAGE: "Copia riuscita",
    _NOTIFICATION1: "Nuovo deposito",
    _NOTIFICATION2: "Profitto Cryptotradex",
    _NOTIFICATION3: "Profitto Unilevel",
    _NOTIFICATION4: "Gamma infinita",
    _NOTIFICATION5: "Acquisto pacchetto",
    _NOTIFICATION7: "Bonus ricorrente di referral diretto",
    _PREV: "Precedente",
    _NEXT: "Successivo",
    _TABLE4_A: "Operazione",
    _TABLE4_B: "Profitto",
    _TABLE4_C: "ROI",
    _TABLE4_D: "Data",
    _SHARED: "Condividi il tuo link di referral",
    _TITLESHARED: "Link di referral",
    _TEXTSHARED:
      "Condividi il tuo link di referral binario e scegli la posizione in cui desideri posizionare il tuo invitato, oppure lascia che venga assegnato casualmente.",
    _RANDOM: "Casuale",
    _CTFLIX:
      "Formati sui modelli di business di tendenza e ad alta redditività con il Web3.",
    _SIGNAL:
      "Ottieni i migliori segnali da un unico posto e moltiplica il tuo capitale.",
    _COPY:
      "Dimentica di dover seguire entrate e uscite — copia tutte le operazioni con un clic.",
    _CTXII:
      "Moltiplica il tuo capitale per 12 automaticamente in collaborazione con CTX. Contatta la persona che ti ha present",
    _ENTER: "Entra",
    _INPOSITION: "Fase di Posizionamento",
  },
  _FINANCE: {
    _DEPOSIT: "Deposito",
    _QR: "Scansiona il seguente QR o copia l'indirizzo",
    _NETWORK: "Rete",
    _INSTRUCTIONS: "Istruzioni per inviare SOLANA (SOL)",
    _STEP1: "Assicurati che la rete selezionata sia SOLANA.",
    _STEP2:
      "Invia la quantità di SOLANA al seguente indirizzo del portafoglio.",
    _COPY: "Copia",
    _DISCLAIMER:
      "Disclaimer: Non siamo responsabili per transazioni effettuate fuori dalla rete SOLANA o per l'invio di criptovalute diverse da SOLANA. Qualsiasi perdita di fondi a causa di questi errori sarà sotto la responsabilità esclusiva del mittente.",
    _TABLE1: "Storico Depositi",
    _TABLE1_A: "Ordine",
    _TABLE1_B: "Importo",
    _TABLE1_C: "Data",
    _TABLE1_D: "Stato",
    _SUCCESS: "Il pacchetto è stato aggiunto con successo",
    _COPYMESSAGE: "Indirizzo del portafoglio copiato con successo",
  },
  _PACKAGES: {
    _ATTENTION:
      "Attenzione: Hai un account aziendale. Acquistando un pacchetto, riavvierai l'account e tutti i suoi benefici.",
    _PACKAGES: "Seleziona il miglior piano per te",
    _SUBTITLE: "Hai 8 opzioni",
    _BALANCE: "Deposito saldo",
    _PACKAGE: "Pacchetto ",
    _PACKAGE_1: "Guadagnerai fino al livello ",
    _PACKAGE_2: "Guadagna fino a",
    _PACKAGE_3: "ROI settimanale",
    _BUTTON1: "Compilato",
    _BUTTON2: "Compra",
    _CALCULATE: "Calcola piano",
    _RECHARGE: "Non hai abbastanza soldi, ricarica il tuo portafoglio",
    _PACKAGEMESSAGE: "Devi acquistare un pacchetto superiore",
    _SUCCESS: "Il pacchetto è stato aggiunto con successo",
    _UPDATE: "Prezzo di aggiornamento del pacchetto",
    _BASIC: "Base",
    _INTERMEDIATE: "Base + Intermedio",
    _ADVANCED: "Base + Intermedio + Avanzato",
    _COMPLETED: "Completato",
    _SIGNALS: "Segnali CTX",
    _COPY: "CopyTrading CTX",
  },
  _NETWORK: {
    _TODAY: "Oggi",
    _AVAILABLE: "Disponibile",
    _WITHDRAW: "Totale ritirato",
    _SEARCHLABEL: "Ricerca per email",
    _SEARCH: "Cerca",
    _NETWORK: "Rete",
    _DIRECTS: "Referenti diretti",
    _SUCCESS: "Ricerca riuscita",
    _ERROR: "Non fa parte del tuo albero.",
    _LEVEL: "Livello",
    _USERS: "Utenti",
    _AMOUNT: "Importo",
    _USERNAME: "Nome utente",
    _EMAIL: "Email",
    _WHATSAPP: "WhatsApp",
    _PACKAGE: "Pacchetto",
    _LEFT: "Sinistra",
    _RIGHT: "Destra",
    _TOTALLEFT: "Cumulative Total Left",
    _TOTALRIGHT: "Cumulative Total Right",
    _BINARYTEXT:
      "Per posizionare il tuo referral nell'albero binario, premi e tieni premuto il pulsante corrispondente (sinistra o destra). Ricorda che questa azione può essere eseguita solo una volta, quindi ti consigliamo di rivedere attentamente la tua selezione prima di confermare.",
    _BINARYSUCCESS: "Transazione completata con successo",
    _BINARYLOADING: "Caricamento...",
    _SEARCHFORUSERNAME: "Cerca per nome utente",
    _TANK: "Serbatoio di referral diretti",
  },
  _PROFILE: {
    _TITLE: "Profilo",
    _NAME: "Il tuo nome",
    _EMAIL: "La tua email",
    _WHATSAPP: "WhatsApp",
    _CURRENTPASSWORD: "Password attuale",
    _PASSWORD: "Nuova password",
    _CONFIRMPASSWORD: "Conferma nuova password",
    _WALLET: "Indirizzo di prelievo",
    _ACTION: "Modifica",
    _TIPS: "Suggerimenti",
    _TIPS_1: "Il nome deve essere leggibile e non superare i 20 caratteri.",
    _TIPS_2:
      "La password deve includere numeri, lettere e simboli; più è complessa, meglio è.",
    _TIPS_3:
      "L'email non può essere modificata. Se hai bisogno di apportare una modifica, scrivi a supporto.",
    _TIPS_4:
      "L'indirizzo di prelievo può essere modificato solo con un autenticatore a 2 fattori, che deve essere abilitato precedentemente.",
    _ERROR_PASSWORD: "Errore nella password precedente",
    _SUCCESS: "Profilo aggiornato con successo",
    _MIN: "Prelievo minimo",
    _UPDATE: "Aggiorna profilo",
  },
  _RECOVERPASSWORD: {
    _RECOVERPASSWORD: "Hai dimenticato la password?",
    _EMAIL: "La tua email",
    _BUTTON: "Invia email",
    _MESSAGE: "La tua password è stata inviata alla tua email",
    _ERROR_EMAIL: "Questa email non è registrata",
  },
  _GLOBALV: {
    _TITLE: "GV",
    _CURRENT: "Rango attuale",
    _NEXT: "Prossimo rango",
    _SILVER: "Argento",
    _GOLD: "Oro",
    _RUBY: "Rubino",
    _EMERALD: "Smeraldo",
    _DIAMOND: "Diamante",
    _DIAMONDB: "Diamante Blu",
    _DIAMONDBB: "Diamante Nero",
    _NONE: "Nessuno",
  },
  _AUTH: {
    _TITLEDEFAULT: "Cambia l'indirizzo di prelievo",
    _TITLE: "Passo 1",
    _TITLE2: "Passo 2",
    _TITLE3: "Passo 3",
    _STEP1: "Scarica e installa l'autenticatore sul tuo dispositivo",
    _STEP2: "Scansiona il codice per salvarlo",
    _FORMEMAIL: "Verifica email",
    _FORMHELPEMAIL: "Inserisci il codice di verifica a 6 cifre inviato a",
    _FORMHELPAUTH:
      "Inserisci il codice a 6 cifre generato dall'App Authenticator",
    _FORM1: "Pin tramite Authenticator",
    _FORM2: "Indirizzo di prelievo",
    _FORMMIN: "L'indirizzo di prelievo deve essere lungo 34 caratteri",
    _FORMCODESEND: "Codice inviato",
    _VERIFF: "Veriff",
    _ACTION: "Verifica e salva",
    _ERROR: "Errore, riprova.",
    _SUCCESS: "Cambio riuscito",
    _RETRYOTP: "Errore nell'invio del codice, riprova.",
    _SENDOTP: "Codice inviato con successo",
    _SUCCESSOTP: "OTP verificato con successo",
    _SUCCESSAUTH2F: "Autenticazione 2FA verificata con successo",
    _ERRORCODE: "Codice invalido, riprova",
  },
  _COUNTDOWN: {
    _TITLE: "Prossimo taglio:",
    _DAYS: "Giorni",
    _HOURS: "Ore",
    _MINUTES: "Minuti",
    _SECONDS: "Secondi",
  },
  _WITHDRAWAL: {
    _TITLE: "Transazioni di Prelievo",
    _ERRORPROCESS: "Hai già un altro prelievo in corso, attendi qualche minuto",
    _ERRORWALLET:
      "Devi prima configurare il tuo portafoglio di prelievo Solana",
    _ERRORBALANCE: "Il saldo negativo viene reiniziato nuovamente.",
    _ERROROTHER: "Errore durante il prelievo, riprova più tardi.",
    _SUCCESS:
      "Prelievo riuscito. Arriverà nel tuo portafoglio in pochi minuti.",
  },
  _SYSTEM: {
    _SYSTEM: "Sistema",
    _GLOBAL: "Globale",
    _INVESTMENT: "Preleva investimento",
    _INVESTMENTTEXT:
      "Ricorda che avrai una penalità del 35% del tuo investimento",
    _ACCELERATE: "Accelera",
    _REPORT: "Rapporto di investimento Cryptotradex",
    _PARNERT: "Informazioni sul patrocinatore",
  },
  _WITHDRAWINVESTMENT: {
    _TITLE: "Preleva investimento",
    _MESSAGE:
      "Prelevare il tuo capitale ora comporta una tariffa operativa del 35% sul tuo investimento - guadagni accumulati, e sarà elaborato entro 24 ore. Se lo fai, fermerai il suo potenziale di crescita immediato. Decidi con una visione a lungo termine!",
    _BUTTON: "Preleva",
    _BUTTONWAIT: "Prelievo in corso",
  },
  _SIGNAL: {
    _NEWS: "Nuovo",
    _SIGNALS: "Segnali",
    _CHAT: "Chat esclusiva",
    _OPEN: "Aperto",
    _CLOSED: "Chiuso",
    _PRICEENTRY: "Prezzo di ingresso",
    _PRICEEND: "Prezzo di chiusura",
    _INITIAL: "Prezzo iniziale",
    _MAXIMUN: "Prezzo massimo ATH",
    _DATEATH: "Data ATH",
    _MKCAP: "Cap di mercato",
  },

  _ACADEMY: {
    _NEWS: "Nuovo",
    _TITLE: "Accademia",
    _WHATIS: "Cos'è Cryptotradex Academy?",
    _DESCRIPTION:
      "Impara a conoscere criptovalute, portafogli, meme e Web3 con la nostra piattaforma online progettata per tutti i livelli.",
    _ACTION1: "Vai all'Accademia",
    _DISABLED: "È richiesto un deposito minimo di 500 USD",
    _TITLANDING: "Diventa un esperto di Cryptomemes",
    _DESCRIPTIONLANDING:
      "Accedi a tutorial esclusivi dal pacchetto BRETT e impara a dominare il mondo dei MEMECOINS.",
    _ACTIONLANDING: "Iscriviti ora e inizia a imparare!",
    _WHATCOURSES: "Quali corsi riceverai?",
    _RECOMMENDS: "Video consigliati",
  },
  _FREE: {
    _FREE: "Gratuito",
    _FREEFOR: "GRATUITO PER UN LUNGO TEMPO",
    _SIGNALS: "Vai ai segnali",
    _LINK: "Link della comunità",
    _TITLE:
      "Unisciti alla nostra comunità WhatsApp per ottenere informazioni immediate e in tempo reale",
    _DISCLAIMER: "Disclaimer",
    _CHANNEL: "Vai al canale",
    _TEXTDISCLAIMER:
      "Questi segnali hanno un periodo di esecuzione, al momento in cui li pubblichiamo nel nostro gruppo di segnali è quando otteniamo il profitto dimostrato.",
    _LEGEND: "Leggenda",
    _NAME: "Nome token",
    _URL: "Link DexScrenner",
    _START: "Orario di inizio",
    _END: "Orario di fine",
    _PROFIT: "Profitto",
    _VER: "Vai",
  },
  _CTFLIX: {
    _BASIC: "Base",
    _INTERMEDIATE: "Intermedio",
    _ADVANCED: "Avanzato",
    _MODULE0: "Modulo Iniziale",
    _MODULE1: "Modulo 1 Sicurezza nelle criptovalute",
    _MODULE2: "Modulo 2 Coinbase",
    _MODULE3: "Modulo 3 Bybit",
    _MODULE4: "Modulo 4 Binance",
    _MODULE5: "Modulo 5 Scambi",
    _MODULE6: "Modulo 6 Strumenti di base",
    _MODULE7: "Modulo 7 Rabby Wallet",
    _MODULE8: "Modulo 8 Phantom Wallet",
    _MODULE9: "Modulo 9 Trezor",
    _MODULE10: "Modulo 10 Ledger",
    _MODULE11: "Modulo 11 Strumenti Onchain",
    _MODULE12: "Modulo 12 Analisi OnChain",
    _MODULE13: "Modulo 13 GMGN",
    _MODULE14: "Modulo 14 Dexscreener Avanzato",
    _MODULE15: "Modulo 15 Bot Bull x NEO",
    _ALLLANGUAGE: "Tutti i linguaggi",
    _ALLTYPES: "Tutti i tipi",
    _ALLLMODULES: "Tutti i moduli",
    _REQUIREDBASIC:
      "Aggiorna il tuo pacchetto e accedi a moduli esclusivi come: Sicurezza in Crypto, Coinbase, Bybit, Binance, e oltre 54 video educativi!",
    _REQUIREDINTERMEDIATE:
      "Non perdere moduli chiave come: Exchanges, Strumenti di Base, e l'uso di Wallet come Rabby Wallet, Phantom, Trezor e Ledger! Aggiorna il tuo pacchetto e mantieni l'accesso a tutto il contenuto.",
    _REQUIREDADVANCED:
      "Non perdere l'accesso a strumenti avanzati come: Analisi Onchain, GMGN, DexScreener e impara a usare il Bot Bull Neo! Aggiorna il tuo pacchetto per esplorare tutto il potenziale di queste piattaforme.",
  },
  _COPY: {
    _TITLE: "Il Mio Portafoglio di Copy Trading",
    _MIN: "Deposito minimo 300 USD",
    _BALANCE: "Saldo",
    _TYPE: "Tipo",
    _CONSERVE: "Conservativo",
    _CONSERVEDESCRIPTION:
      "Basso rischio, stabilità e conservazione del capitale.",
    _MODERADE: "Moderato",
    _MODERADEDESCRIPTION: "Equilibrio tra rischio e crescita.",
    _ADVANCED: "Aggressivo",
    _ADVANCEDDESCRIPTION:
      "Alto rischio, alti rendimenti potenziali, alta volatilità.",
    _SLIPPAGE: "Slippage",
    _SUPPLY: "Importo da operare",
    _TIME: "Tempo",
    _STATISTICS: "Statistiche",
    _DISCLAIMER:
      "Per attivare il sistema di copy trading, è necessario effettuare un deposito iniziale con un importo minimo di <strong class='text-red-300'>300 USD</strong>. Una volta completato questo passaggio, il sistema passerà attraverso una fase di configurazione che può richiedere da 24 a 72 ore lavorative. <br/> <br/> Dopo questa fase, il sistema inizierà a operare in tempo reale, replicando le strategie del nostro team di trader. <br/> <br/> È importante sottolineare che non siamo obbligati a eseguire operazioni ogni giorno. Operiamo solo quando le condizioni di mercato sono favorevoli, evitando rischi inutili. <br/> <br/> Questo sistema non garantisce rendimenti costanti. Gli utenti accettano che guadagni e perdite fanno parte del comportamento naturale del mercato, che è libero e non manipolato. In caso di perdite, non verranno accettati reclami. <br/> <br/> Tuttavia, siamo profondamente orgogliosi delle nostre conoscenze ed esperienze e agiamo con responsabilità in ogni decisione presa. <br/> <br/> Infine, l'intero processo di copy trading include una fase di configurazione e verifica manuale, nella quale vengono convalidati i dati dell'utente e le informazioni del sistema prima dell'attivazione.",
    _ACTION: "Azioni",
    _PORTFOLIO: "Portafoglio",
    _CAPITAL: "Ritirare Capitale",
    _EARNINGS: "Ritirare Guadagni",
    _CONNECTION: "Connessione",
  },
  _NOTICE: {
    _NOTICE: "Avviso Stellare",
    _CRYPTOCARD: "CryptoCard sta arrivando",
    _DESCRIPTION: "La nostra carta, preparati a un'esperienza totale.",
    _NEW: "Nuovo membro?",
    _DISCOVERY: "Scopri tutto ciò che abbiamo per",
    _YOU: "te",
    _MYBUSINESS: "La mia attività",
    _MYPRODUCTS: "I miei prodotti",
  },
  _STATISTICS: {
    _FROM: "Da",
    _UNTIL: "Fino a",
    _NUMBERSOPERATIONS: "Numero di transazioni",
  },
};
